// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"9f8917ae875bfeb5","src_app_modules_claim-management-screen_claim-management-screen_module_ts":"769eeeb83bb05f30","src_app_modules_booking-management-screen_booking-management-screen_module_ts":"f33e6a0564d01bbf"}[chunkId] + ".js";
};